import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import { Color as PColor } from '../../utils/types/palette';
import { sizeMenuItemMixin } from './menu-item.mixin';
import { Size } from './types';
var baseClassName = 'MenuItem';
var Icon = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'Icon')
}).withConfig({
  componentId: "sc-rrzye0-0"
})(function (_ref) {
  var palette = _ref.theme.palette,
    disabled = _ref.disabled;
  return css(["flex-shrink:0;margin-right:10px;color:", ";"], disabled ? palette[PColor.TextPlaceholder] : palette[PColor.IconsPrimary]);
});
var Actions = /*#__PURE__*/styled(Icon).attrs({
  className: generateClassNames(baseClassName, 'Actions')
}).withConfig({
  componentId: "sc-rrzye0-1"
})(function () {
  return css(["margin-right:0px;margin-left:16px;"]);
});
var Label = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'Label')
}).withConfig({
  componentId: "sc-rrzye0-2"
})(["align-items:center;column-gap:4px;flex-grow:1;"]);
var MenuItemWrapper = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'wrapper')
}).withConfig({
  componentId: "sc-rrzye0-3"
})(function (_ref2) {
  var _ref2$divider = _ref2.divider,
    divider = _ref2$divider === void 0 ? false : _ref2$divider,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    theme = _ref2.theme;
  return css(["", " ", ""], divider && css(["width:100%;height:1px;background:", ";box-sizing:border-box;margin:4px 0;"], theme.palette[PColor.BordersSecondary]), disabled && css(["color:", ";"], theme.palette[PColor.ButtonDisabledText]));
});
var MenuItem = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-rrzye0-4"
})(function (_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? Size.Sm : _ref3$size,
    $active = _ref3.$active,
    theme = _ref3.theme,
    _ref3$disableHover = _ref3.disableHover,
    disableHover = _ref3$disableHover === void 0 ? false : _ref3$disableHover,
    disabled = _ref3.disabled,
    $isFocused = _ref3.$isFocused;
  return css(["display:flex;justify-content:space-between;flex-direction:row;align-items:center;width:100%;background:", ";color:", ";cursor:pointer;box-sizing:border-box;transition:all 100ms ease-out;", " &:focus-within,&:focus,&:hover{", ";", "}", " ", ""], theme.palette[$active ? PColor.BackgroundActive : PColor.BackgroundSecondary], theme.palette[PColor.TextPrimary], sizeMenuItemMixin[size], !disableHover && css(["background-color:", ";"], theme.palette[PColor.BackgroundHover]), disabled && css(["cursor:default;background-color:white;"]), disabled && css(["& > svg{path{fill:", ";}}color:", ";"], theme.palette[PColor.ButtonDisabledText], theme.palette[PColor.ButtonDisabledText]), $isFocused && !disableHover && css(["background-color:", ";"], theme.palette[PColor.BackgroundHover]));
});
var MenuPrefix = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'prefix')
}).withConfig({
  componentId: "sc-rrzye0-5"
})(function () {
  return css(["display:flex;"]);
});
var MenuContent = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'content')
}).withConfig({
  componentId: "sc-rrzye0-6"
})(function () {
  return css(["flex-grow:1;line-height:16px;"]);
});
var MenuSuffix = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'suffix')
}).withConfig({
  componentId: "sc-rrzye0-7"
})(function () {
  return css(["display:flex;margin-left:8px;"]);
});
var Styled = applyDisplayNames({
  MenuItemWrapper: MenuItemWrapper,
  MenuItem: MenuItem,
  MenuPrefix: MenuPrefix,
  MenuContent: MenuContent,
  MenuSuffix: MenuSuffix,
  Label: Label,
  Icon: Icon,
  Actions: Actions
});
export default Styled;